import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ShipmentBasisStations } from '@prlw/core/monitor/shipment-basis-stations.entity';
import { BasisDetailsInterface } from '../../basis-details.interface';

const MAX_TO_SHOW = 5;

@Component({
  selector: 'prlw-table-tooltip-basis-ui',
  templateUrl: './table-tooltip-basis.component.html',
  styleUrls: ['./table-tooltip-basis.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableTooltipBasisComponent {
  @Input() public basisDetails!: BasisDetailsInterface;
  public maxAmountToShow = MAX_TO_SHOW;

  public get pricingPoints(): ShipmentBasisStations[] {
    return this.basisDetails.stations.filter(
      (station: ShipmentBasisStations) => station.isPricingPoint,
    );
  }

  public get stations(): ShipmentBasisStations[] {
    return this.basisDetails.stations.filter(
      (station) => !station.isPricingPoint,
    );
  }

  public get hasForecast(): boolean {
    return Boolean(
      this.basisDetails.forecastTrend && this.basisDetails.forecastDate,
    );
  }

  public get forecastDescription(): string {
    return this.basisDetails.forecastDescription;
  }
}
